import Section from 'components/Section'
import { Typography, MediaImageStandard } from 'components/Contentful'
import { AchieveTheme, Grid } from '@achieve/ascend'
import { Carousel } from 'components/Carousels'

function Card({ item: { cardImage, cardTitleText, cardText }, priority }) {
  const textList = cardText?.json?.content ?? []
  const quote = textList?.[0]?.content ? { json: textList[0], links: cardText.links } : ''
  const attribution = textList?.[1]?.content ? { json: textList[1], links: cardText.links } : ''

  return (
    <Grid
      container
      direction={{ xs: 'column-reverse', lg: 'row' }}
      justifyContent={{ xs: 'flex-end', lg: 'space-between' }}
      alignItems={{ xs: 'center', lg: 'flex-start' }}
    >
      <Grid item xs={12} lg={4}>
        <div
          className={
            'max-w-[415px] max-h-[295px] aspect-square min-w-[295px] lg:max-h-[415px] [&_img]:w-full [&_img]:h-full [&_img]:rounded-xl'
          }
        >
          <MediaImageStandard content={cardImage} priority={priority} />
        </div>
      </Grid>
      <Grid item xs={12} lg={7}>
        <Grid
          container
          direction="column"
          className={'text-center mb-8 px-10 lg:text-left lg:mb-0 lg:px-0'}
        >
          <Grid item xs={12}>
            <Typography
              className="displayMd lg:displayLg !font-bold mb-8 lg:mb-16"
              content={cardTitleText}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              className="displaySm lg:displayMd !font-medium mb-6 lg:mb-16"
              content={quote}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography content={attribution} className="bodyXs lg:headingMd !font-light" />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

function FlatCarousel({ carouselItems, idPrefix = 'page' }) {
  // If the image is nested in a scrollable parent element other than the root document,
  // you will also need to assign the lazyRoot prop
  // https://nextjs.org/docs/api-reference/next/image#lazyroot
  // https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/root

  return (
    <Section
      backgroundColor={AchieveTheme?.ascend?.colors?.blue[500]}
      className={'text-white py-8 lg:pt-16 lg:pb-6'}
      contain={false}
    >
      <Carousel
        className={'!pt-0 lg:!px-24'}
        carouselItems={carouselItems}
        itemComponent={Card}
        variant="standard"
        idPrefix={`${idPrefix}-testimonial-carousel`}
        classNameIndicatorDots={'mt-8'}
        withIndicators
      />
    </Section>
  )
}

export { FlatCarousel }
